import React from 'react';
import { uid } from 'react-uid';
import type { EmailTemplate } from '../../emailTypes';
import './EmailTemplateList.scss';
import EmailTemplateListItem from './EmailTemplateListItem/EmailTemplateListItem';

type Props = {
	onSelect: (template: EmailTemplate) => void;
	onCancel: () => void;
	onSave?: (payload: EmailTemplate) => void;
	onDelete: (id: string) => void;
	onDuplicate: (payload: EmailTemplate) => void;
	onPin: (payload: EmailTemplate) => void;
	templates: EmailTemplate[];
	showCreate?: boolean;
};

export default function EmailTemplateList({
	onSelect,
	showCreate = false,
	onCancel,
	onSave,
	onDelete,
	onDuplicate,
	onPin,
	templates = []
}: Props): JSX.Element {
	return (
		<div className="emailTemplateList template-item-holder relative mb-6 h-full pt-4">
			<div className="emailTemplateList-wrapper overflow-hidden rounded border border-solid">
				<div className="emailModal-scroll flex flex-col overflow-y-auto">
					{showCreate && (
						<>
							<span>
								<EmailTemplateListItem
									isEditable
									onCancel={onCancel}
									onSave={onSave}
								/>
							</span>
						</>
					)}
					{templates.map((template, index) => {
						const templateNew = template;

						return (
							<EmailTemplateListItem
								key={uid(template, index)}
								name={template.name}
								template={template}
								defaultTemplate={
									template.defaultTemplate === true
								}
								isAISnippet={template.body?.includes(
									'[ai_snippet]'
								)}
								onSelect={() => onSelect(template)}
								onDelete={() => onDelete(template.id as string)}
								onDuplicate={() => onDuplicate(template)}
								onSave={({ name: templateName }) => {
									delete templateNew.pinDate;

									templateNew.name = templateName;

									onSave(templateNew);
								}}
								onPin={() => {
									templateNew.pin = !template.pinDate;

									if (templateNew.pin) {
										templateNew.pinDate = new Date();
									} else {
										templateNew.pinDate = undefined;
									}

									onPin(templateNew);
								}}
								pined={!!template.pinDate}
							/>
						);
					})}
				</div>
			</div>
		</div>
	);
}
